// @ts-nocheck
import { useEffect, useRef, useState, type ReactNode } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  BookOpen,
  Copy,
  Facebook,
  HeartPulse,
  Images,
  Instagram,
  LayoutGrid,
  Loader2,
  PenLine,
  Link2,
  ListTodo,
  MessageCircle,
  MessageSquare,
  Palette,
  Pause,
  Play,
  RefreshCw,
  Settings,
  ShoppingBag,
  Sparkles,
  StickyNote,
  Trash2,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import { api, CarouselItem, type CarouselInspirationBorrow, type CarouselLayoutQa } from "@/lib/api";
import { TONE_CLASS, type SettingsTone } from "@/lib/carouselSettingsMeta";
import { copyText, packFromItem } from "@/lib/carouselGenerationPack";
import {
  recommendCta,
  SOURCE_EMPTY,
  STATUS_TIPS,
  STUDIO_TAB_META,
  STUDIO_TIPS,
  houseCanonState,
  studioTabFromHash,
  studioTabToHash,
  type AbVariable,
  type BgMode,
  type CloseMode,
  type CtaIntent,
  type StudioTab,
} from "@/lib/carouselStudioMeta";
import { type ConceptsTraceOutgoing } from "@/lib/carouselGenerationPack";
import PageHeader from "@/components/PageHeader";
import AiJobModal, { type AiJobKind, type AiJobParam } from "@/components/AiJobModal";
import { CopyReviewChanges } from "@/components/CopyReviewChanges";
import CopyChatPanel from "@/components/CopyChatPanel";
import { AiActionButton, BriefPreview, CopyOutcomePanel, CtaIo, StudioProcessChain, StudioSplit, StudioTabsList } from "@/components/studioTabs";
import { StudioModalBody, StudioModalFooter, StudioModalFrame, StudioModalHeader } from "@/components/StudioModalFrame";
import { DesignAnalysisCard, DesignLayoutNoteCard, HouseCanonBar, StudioOptionCard } from "@/components/DesignReviewPanel";
import CarouselReelPanel from "@/components/CarouselReelPanel";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { emitInlineMarkdown, type TextMark } from "@/lib/carouselTextMarks";
import { copyRenderBlockedReason } from "@/lib/studioVoice";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { InfoTip, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { OpRoleBadge } from "@/components/op/OpRoleBadge";
import { OP_RESULT_CARD, OP_SURFACE } from "@/lib/opSurfaces";


import * as Helpers from "../helpers";
import CzasotekstPanel from "@/components/CzasotekstPanel";
const { ideaDescription, firstSlideField, isHeadlineSlide, slideHasCopy, previewMarks, CopyMarkdownCheat, CopyMarkdownField, flattenSlide, FinalSlidesModal, SourceSection, SourceHits, InspirationPanel, Chip, CopyPackButton, FieldLabel, TipBadge, CostFooter, tabForExisting, CarouselQueueList, QueueRow } = Helpers;

export default function CopyTab({ ctx }: { ctx: any }) {
  const {
    BORROW_CHIPS,
    DEFAULT_BORROW,
    STATUS_LABEL,
    abPairId,
    abVariable,
    abortLlmM,
    activeMode,
    aiAbort,
    aiError,
    aiFailed,
    aiJob,
    aiJobParams,
    aiStatusLabel,
    analyzeInspM,
    approveM,
    askDelete,
    bgHint,
    bgMode,
    book,
    bookHits,
    bookSectionHits,
    borrow,
    borrowM,
    briefBody,
    cancelRenderM,
    caption,
    captionFeedback,
    captionJobSteps,
    captionM,
    captionOnlyJob,
    captionRunning,
    catalog,
    catalogLabel,
    catalogQ,
    catalogTypes,
    changeTrack,
    clickAi,
    closeMode,
    commentHits,
    commitCopyField,
    composeIndex,
    composeMode,
    composeModeM,
    composeSlide,
    conceptsRunning,
    copyApproved,
    copyBusy,
    copyChatM,
    copyChatUndoM,
    copyFeedback,
    copyMdRef,
    copyReviewOnDemandM,
    copyReviseRunning,
    copyRunning,
    copySlides,
    createM,
    ctaIntent,
    ctaM,
    ctaTouched,
    currentQ,
    deleteM,
    designApplyM,
    designApplyRunning,
    designFeedbackM,
    designFixM,
    designFixRunning,
    designQa,
    designReviewM,
    designReviewRunning,
    draftText,
    effectiveClose,
    effectiveIntent,
    finalPreview,
    forcePick,
    formatId,
    fromDraftM,
    fromDraftRunning,
    fromPubM,
    funnel,
    generateCopyM,
    goTab,
    hasComposedSlides,
    hasCopySlides,
    hasSelectedIdea,
    houseCanon,
    inspirationRunning,
    isAiTrack,
    isOperator,
    item,
    itemMode,
    jobRunning,
    layoutPlanM,
    layoutPlanRunning,
    layoutQa,
    layoutQaM,
    layoutQaRunning,
    listQ,
    llmIs,
    mergeCopySlides,
    messengerHits,
    musicStatusQ,
    note,
    openExisting,
    pain,
    patchCopyM,
    pauseM,
    pickTrack,
    proposeMusicQ,
    publishBusy,
    publishRunning,
    qaBlocks,
    qaFailed,
    qaLabel,
    qaOverride,
    qc,
    rankingQ,
    ratingM,
    recCta,
    recomposeM,
    syncSlideCopyM,
    reelM,
    reelRunning,
    renderM,
    renderRunning,
    resetStudio,
    retroM,
    retroRunning,
    retryPublishM,
    reviseCopyM,
    applyCopyReviewM,
    scheduleM,
    searchMusicM,
    selectM,
    selectedId,
    selectedIdea,
    setAbPairId,
    setAbVariable,
    setAiJob,
    setBgHint,
    setBgMode,
    setBook,
    setBorrow,
    setCaption,
    setCaptionFeedback,
    setCloseMode,
    setComposeIndex,
    setComposeMode,
    setCopyFeedback,
    setCopySlides,
    setCtaIntent,
    setCtaTouched,
    setDraftText,
    setFinalPreview,
    setForcePick,
    setFormatId,
    setFunnel,
    setNote,
    setPain,
    setQaOverride,
    setSelectedId,
    setSku,
    setStudioTab,
    setStyleId,
    setVisualPackId,
    setTool,
    setTraceId,
    setTraceOut,
    setUrls,
    setUseBook,
    setUseComments,
    setUseMessenger,
    setUseStories,
    setVerifyCta,
    setWhen,
    showPicker,
    sku,
    slot,
    slotQ,
    sourceHits,
    sourcesQ,
    startConcepts,
    startPost,
    statusQ,
    storyHits,
    studio,
    studioTab,
    styleId,
    visualPackId,
    templateM,
    tool,
    traceId,
    traceItem,
    traceOut,
    uploadInspM,
    urls,
    useBook,
    useComments,
    useMessenger,
    useStories,
    verifyCta,
    voiceHits,
    when
  } = ctx;
  const [activeSlide, setActiveSlide] = useState(0);
  const chatMessages = Array.isArray(item?.discussion?.copy_chat) ? item.discussion.copy_chat : [];
  const canUndoChat = Boolean(item?.discussion?.copy_chat_undo?.copy);
  const chatBusy =
    copyChatM?.isPending ||
    item?.llm_status === "copy_chat" ||
    copyReviewOnDemandM?.isPending ||
    item?.llm_status === "review";

  useEffect(() => {
    if (!copySlides?.length) {
      setActiveSlide(0);
      return;
    }
    if (activeSlide >= copySlides.length) setActiveSlide(copySlides.length - 1);
  }, [copySlides?.length, activeSlide]);

  const isCzasotekst = item?.kind === "czasotekst";
  if (isCzasotekst && item) {
    return (
      <TabsContent value="copy" className="mt-0">
        <CzasotekstPanel
          item={item}
          caption={caption}
          onCaption={setCaption}
          onHook={(v) => {
            /* hook synced in panel */
            void v;
          }}
        />
      </TabsContent>
    );
  }
  return (
        <TabsContent value="copy" className="mt-0 space-y-5">
        <StudioSplit
          left={
        <div className="space-y-5">
        {showPicker ? (
        <Card id="concepts" className="border-slate-200 bg-white shadow-sm">
          <CardHeader>
            <CardTitle className="text-base text-slate-900">Koncepcje</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground">Najpierw wybierz przebieg w briefie.</p>
          </CardContent>
        </Card>
        ) : isOperator ? (
        <Card id="concepts" className="border-slate-200 bg-white shadow-sm">
          <CardHeader>
            <CardTitle className="text-base text-slate-900">Koncepcje</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-muted-foreground">Pominięte. Tor własny tekst nie składa 4 kart.</p>
            {item ? (
              <InspirationPanel
                item={item}
                uploadM={uploadInspM}
                analyzeM={analyzeInspM}
                track="operator"
                onAnalyze={(opts) => clickAi("inspiration", () => analyzeInspM.mutate(opts))}
              />
            ) : null}
          </CardContent>
        </Card>
        ) : (
        <Card id="concepts" className="border-slate-200 bg-white shadow-sm">
          <CardHeader>
            <CardTitle className="flex items-center justify-between gap-2 text-base text-slate-900">
              <span>Koncepcje {item?.short_id ? `· ${item.short_id}` : ""}</span>
              {item?.latest_generation?.pack || (item?.ideas?.length || 0) >= 4 ? (
                <CopyPackButton item={item} outgoing={traceOut} />
              ) : null}
            </CardTitle>
          </CardHeader>
          <CardContent>
            {!item && <p className="text-sm text-muted-foreground">Wybierz brief albo karuzelę z kolejki.</p>}
            {(item?.llm_status === "concepts" || item?.llm_status === "inspiration") && (
              <p className="mb-2 text-sm text-muted-foreground">{item.llm_detail || "Składam 4 kąty…"}</p>
            )}
            {item ? (
              <InspirationPanel
                item={item}
                uploadM={uploadInspM}
                analyzeM={analyzeInspM}
                track="ai"
                onAnalyze={(opts) => clickAi("inspiration", () => analyzeInspM.mutate(opts))}
              />
            ) : null}
            {(item?.ideas || []).length > 0 && (
              <p className="mb-2 text-xs text-muted-foreground">
                Klik zaznacza kartę. Typ i styl ustawiasz niżej. Generator startuje dopiero po „Generuj treść”.
              </p>
            )}
            <div id="studio-concepts" className={cn("space-y-3 p-3", OP_SURFACE.result.box)}>
              <OpRoleBadge tone="result" label="Koncepcje" />
              <div className="grid gap-3 md:grid-cols-2">
              {(item?.ideas || []).map((idea) => (
                <button
                  key={idea.id}
                  type="button"
                  disabled={selectM.isPending || copyBusy}
                  onClick={() => {
                    if (idea.selected) return;
                    selectM.mutate(idea.id);
                  }}
                  className={cn(
                    "p-3 text-sm transition-colors",
                    idea.selected ? OP_RESULT_CARD.selected : OP_RESULT_CARD.idle,
                  )}
                >
                  <div className="mb-1 flex items-center justify-between gap-2">
                    <Badge variant="outline">{idea.format_id || idea.format_source}</Badge>
                    <span className="text-xs text-muted-foreground">{idea.format_note}</span>
                  </div>
                  <div className="font-medium">{idea.hook}</div>
                  {ideaDescription(idea) ? (
                    <p className="mt-2 text-xs text-muted-foreground">{ideaDescription(idea)}</p>
                  ) : null}
                  {idea.effect ? (
                    <p className="mt-2 text-xs">
                      <span className="font-medium">Efekt: </span>
                      {idea.effect}
                    </p>
                  ) : null}
                </button>
              ))}
              </div>
            </div>
          </CardContent>
        </Card>
        )}

        {(item?.layout_plan?.slides?.length || item?.llm_status === "layout_plan" || layoutPlanM.isPending) && (
          <Card id="layout-plan" className="border-slate-200 bg-white shadow-sm">
            <CardHeader>
              <CardTitle className="text-base text-slate-900">Plan układu</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
              {item?.llm_status === "layout_plan" || layoutPlanM.isPending ? (
                <p className="text-sm text-muted-foreground">{item?.llm_detail || "Dobieram rytm ścian…"}</p>
              ) : null}
              {item?.layout_plan?.rationale ? (
                <p className="text-sm text-foreground">{item.layout_plan.rationale}</p>
              ) : null}
              {item?.layout_plan?.format_id ? (
                <p className="text-xs text-muted-foreground">
                  Typ: {item.layout_plan.format_id}
                  {item.layout_plan.pattern ? ` · wzorzec ${item.layout_plan.pattern}` : ""}
                </p>
              ) : null}
              <div className={cn("grid gap-2 p-3 md:grid-cols-2", OP_SURFACE.result.box)}>
                {(item?.layout_plan?.slides || []).map((row) => (
                  <div key={`${row.index}-${row.recipe}`} className={cn("p-2 text-xs", OP_RESULT_CARD.static)}>
                    <div className="font-medium">
                      Slajd {row.index}: {row.recipe}
                    </div>
                    {row.why ? <p className="mt-1 text-muted-foreground">{row.why}</p> : null}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        )}

        <Card id="copy" className="border-slate-200 bg-white shadow-sm">
          <CardHeader>
            <CardTitle className="text-base text-slate-900">Copy slajdów</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {item && (
              <div className="grid gap-4 xl:grid-cols-2">
                <div>
                  <FieldLabel tip={STUDIO_TIPS.copyType} icon={LayoutGrid} tone="primary">
                    Typ tej karuzeli
                  </FieldLabel>
                  <div className="flex flex-wrap gap-1.5">
                    <Chip
                      active={!item.format_id}
                      onClick={() => templateM.mutate({ format_id: "" })}
                      tip={STUDIO_TIPS.mix}
                      tone="primary"
                    >
                      mieszanka
                    </Chip>
                    {catalogTypes.map((fmt) => (
                      <Chip
                        key={fmt.id}
                        active={item.format_id === fmt.id}
                        onClick={() => templateM.mutate({ format_id: fmt.id })}
                        tip={fmt.hint || fmt.label}
                        tone="primary"
                      >
                        {fmt.label}
                      </Chip>
                    ))}
                  </div>
                  {item.status === "idea" && (
                    <p className="mt-1 text-[11px] text-muted-foreground">
                      Zmiana typu przebuduje 4 koncepcje, dopóki nie wybierzesz jednej.
                    </p>
                  )}
                  {item.status === "draft" && !hasCopySlides && !copyBusy && (
                    <p className="mt-1 text-[11px] text-muted-foreground">
                      {isOperator
                        ? "Typ i styl zapiszą się do tej karuzeli. Tekst startuje po Zredaguj slajdy."
                        : "Typ i styl zapiszą się do tej karuzeli. Potem kliknij Generuj treść."}
                    </p>
                  )}
                </div>
                <div>
                  <FieldLabel tip={STUDIO_TIPS.visualPack} icon={Palette} tone="secondary">
                    Szablon wizualny
                  </FieldLabel>
                  <div className="mb-3 flex flex-wrap gap-2">
                    <Chip
                      active={!(item.visual_pack_id || visualPackId)}
                      onClick={() => templateM.mutate({ visual_pack_id: "" })}
                      tip="Bez paczki rytmu"
                    >
                      Bez paczki
                    </Chip>
                    {(catalog?.visual_packs || []).map((pack) => (
                      <Chip
                        key={pack.id}
                        active={(item.visual_pack_id || visualPackId) === pack.id}
                        onClick={() => templateM.mutate({ visual_pack_id: pack.id })}
                        tip={pack.hint || pack.label}
                      >
                        {pack.label}
                      </Chip>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {item?.quality_flags && item.quality_flags.length > 0 && (
              <div className="text-xs text-destructive">Flagi: {item.quality_flags.join(", ")}</div>
            )}
            {!hasCopySlides && (
              <div className="space-y-2">
                {selectedIdea && ideaDescription(selectedIdea) ? (
                  <p className="rounded-md border border-border bg-muted/30 p-3 text-sm">
                    {ideaDescription(selectedIdea)}
                  </p>
                ) : null}
                <p className="text-sm text-muted-foreground">
                  {copyBusy
                    ? item?.llm_detail || (isOperator ? "Wstawiam szkic na ściany…" : "Role rozmawiają, redaktor składa slajdy…")
                    : isOperator
                      ? "Wklej szkic i kliknij Zredaguj slajdy."
                      : hasSelectedIdea
                        ? "Koncepcja wybrana. Ustaw typ i styl, potem Generuj treść."
                        : "Wybierz koncepcję, ustaw typ i styl, potem Generuj treść."}
                </p>
              </div>
            )}
            {isAiTrack && !hasCopySlides ? (
            <div className="space-y-2">
              <FieldLabel tip={STUDIO_TIPS.copyFeedback} icon={StickyNote} tone="muted">
                Twoja uwaga do modelu
              </FieldLabel>
              <textarea
                className="min-h-[72px] w-full rounded-md border border-input bg-transparent p-2 text-sm"
                placeholder="za mało treści na kartach 2-4, rozwiń każdą do dwóch zdań…"
                value={copyFeedback}
                disabled={!item || !hasSelectedIdea || copyBusy}
                onChange={(e) => setCopyFeedback(e.target.value)}
              />
            </div>
            ) : null}
            <div id="studio-primary-cta" className="flex flex-wrap items-start gap-3">
              {hasCopySlides ? (
                <>
                  <AiActionButton
                    className="w-auto"
                    label="Złóż obrazki"
                    io="render"
                    running={renderRunning}
                    failed={item?.render_status === "failed" || renderM.isError}
                    disabled={!item || copyBusy || renderRunning || Boolean(copyRenderBlockedReason(item))}
                    onClick={() => {
                      goTab("render");
                      clickAi("render", () =>
                        renderM.mutate((item?.bg_mode || bgMode || "flat") === "flat" || !studio?.gemini_ready),
                      );
                    }}
                    icon={<Images className="mr-2 h-3.5 w-3.5" />}
                  />
                  {copyRenderBlockedReason(item) ? (
                    <p className="w-full text-xs text-amber-800">
                      Najpierw wdróż poprawki z recenzji (albo popraw treść), potem złóż obrazki.
                    </p>
                  ) : null}
                </>
              ) : null}
              {isAiTrack ? (
              <AiActionButton
                className="w-auto"
                label={hasCopySlides ? "Generuj treść ponownie" : "Generuj treść"}
                io="copy"
                variant={hasCopySlides ? "outline" : "brand"}
                running={copyRunning && !copyReviseRunning}
                failed={generateCopyM.isError || item?.llm_status === "error"}
                disabled={!item || !hasSelectedIdea}
                onClick={() => clickAi("copy", () => generateCopyM.mutate())}
                icon={<MessageSquare className="mr-2 h-3.5 w-3.5" />}
              />
              ) : null}
            </div>
            {hasCopySlides ? (
              <p className="text-xs text-muted-foreground">{STUDIO_TIPS.copyChat}</p>
            ) : null}
          </CardContent>
        </Card>
        </div>
          }
          right={
            <div className="space-y-5">
              <CopyOutcomePanel item={item} selectedHook={selectedIdea?.hook} />
              {isAiTrack && !!item?.discussion?.panel?.length && !hasCopySlides ? (
                <Card className="border-slate-200 bg-white shadow-sm">
                  <CardHeader>
                    <CardTitle className="text-base text-slate-900">Transkrypt ról</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-2 text-sm">
                    {item.discussion.verdict ? <p className="text-xs">{item.discussion.verdict}</p> : null}
                    <div className="grid gap-2">
                      {item.discussion.panel.map((voice, i) => (
                        <div key={`${voice.role}-${i}`} className="rounded bg-muted/40 p-2 text-xs">
                          <div className="mb-1 font-medium">{voice.role}</div>
                          <p className="whitespace-pre-wrap text-muted-foreground">{voice.text}</p>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ) : null}
              {item?.discussion?.copy_review ? (
                <Card className="border-slate-200 bg-white shadow-sm">
                  <CardHeader>
                    <CardTitle className="flex flex-wrap items-center justify-between gap-2 text-base text-slate-900">
                      Recenzja copy
                      <Badge variant={item.discussion.copy_review.verdict === "ok" ? "success" : "outline"}>
                        {item.discussion.copy_review.verdict || "brak werdyktu"}
                      </Badge>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-2 text-sm">
                    <p className="text-xs text-muted-foreground">{STUDIO_TIPS.copyReview}</p>
                    {item.discussion.copy_review.error ? (
                      <p className="text-xs text-destructive">{item.discussion.copy_review.error}</p>
                    ) : null}
                    {!hasCopySlides ? (
                    <div className="grid gap-2">
                      {(item.discussion.copy_review.panel || []).map((voice, i) => (
                        <div key={`review-${voice.role}-${i}`} className="rounded bg-muted/40 p-2 text-xs">
                          <div className="mb-1 font-medium">{voice.role}</div>
                          <p className="whitespace-pre-wrap text-muted-foreground">{voice.text}</p>
                        </div>
                      ))}
                    </div>
                    ) : (
                      <p className="text-xs text-muted-foreground">
                        Głosy ról są w czacie. Tu zostają tylko poprawki do wdrożenia.
                      </p>
                    )}
                    <CopyReviewChanges
                      actions={item.discussion.copy_review.actions || []}
                      reviewVerdict={item.discussion.copy_review.verdict || ""}
                      itemId={item.id}
                      disabled={copyBusy || !hasCopySlides}
                      pending={applyCopyReviewM.isPending}
                      error={applyCopyReviewM.isError ? (applyCopyReviewM.error as Error)?.message : ""}
                      onApply={(ids, rejectIds) =>
                        applyCopyReviewM.mutate({ actionIds: ids, rejectIds })
                      }
                    />
                  </CardContent>
                </Card>
              ) : (
                <p className="text-sm text-muted-foreground">
                  {hasCopySlides
                    ? "Recenzja ról pojawi się po przycisku Review ról w czacie."
                    : "Tu pojawi się transkrypt i recenzja po generatorze treści."}
                </p>
              )}
            </div>
          }
        />
        {hasCopySlides ? (
          <div id="copy-slides" className="grid gap-4 xl:grid-cols-2">
            <Card className="min-w-0 border-slate-200 bg-white shadow-sm">
              <CardContent className="space-y-3 pt-6">
                <p className="text-[11px] text-muted-foreground">
                  Zakładki slajdów: edytujesz markdown ręcznie. Złóż bierze już zjedzony tekst.
                </p>
                <CopyMarkdownCheat />
                <div className="flex flex-wrap gap-1.5">
                  {copySlides.map((slide, idx) => (
                    <button
                      key={`tab-${slide.type || "s"}-${idx}`}
                      type="button"
                      className={cn(
                        "rounded-md border px-2.5 py-1 text-xs",
                        activeSlide === idx
                          ? "border-slate-900 bg-slate-900 text-white"
                          : "border-border bg-background text-muted-foreground hover:text-foreground",
                      )}
                      onClick={() => setActiveSlide(idx)}
                    >
                      Slajd {idx + 1}
                    </button>
                  ))}
                </div>
                {(() => {
                  const idx = Math.min(activeSlide, Math.max(0, copySlides.length - 1));
                  const slide = copySlides[idx] || {};
                  const source = slideHasCopy(slide)
                    ? slide
                    : (item?.copy?.slides?.[idx] as Record<string, unknown>) || slide;
                  const haslo = String(source.text || source.heading || "");
                  const opis = String(source.sub || source.body || "");
                  return (
                    <div className="rounded-md border border-border p-3">
                      <div className="mb-2 text-[11px] uppercase tracking-wide text-muted-foreground">
                        {idx + 1}. {String(source.type || "treść")}
                      </div>
                      {isHeadlineSlide(source) ? (
                        <div className="flex flex-col gap-2">
                          <CopyMarkdownField
                            label="Hasło"
                            text={haslo}
                            marks={previewMarks(source, "text", haslo)}
                            bold
                            minHeightClass="min-h-[58px]"
                            disabled={copyBusy || !selectedId}
                            onDraft={(next) => {
                              copyMdRef.current[`${idx}:text`] = next;
                            }}
                            onCommit={(next) => commitCopyField(idx, "text", next)}
                          />
                          <CopyMarkdownField
                            label="Opis"
                            text={opis}
                            marks={previewMarks(source, "sub", opis)}
                            minHeightClass="min-h-[144px]"
                            fill
                            disabled={copyBusy || !selectedId}
                            onDraft={(next) => {
                              copyMdRef.current[`${idx}:sub`] = next;
                            }}
                            onCommit={(next) => commitCopyField(idx, "sub", next)}
                          />
                        </div>
                      ) : (
                        <div className="whitespace-pre-wrap rounded-md border border-input bg-muted/30 p-2 text-sm">
                          {flattenSlide(source) || "brak"}
                        </div>
                      )}
                      {hasComposedSlides &&
                      (item?.slides || []).some((s: any) => Number(s.index_n) === idx + 1) ? (
                        <div className="mt-3 space-y-1">
                          <Button
                            type="button"
                            size="sm"
                            variant="outline"
                            disabled={copyBusy || !selectedId || syncSlideCopyM.isPending}
                            onClick={() => syncSlideCopyM.mutate(idx + 1)}
                          >
                            {syncSlideCopyM.isPending && syncSlideCopyM.variables === idx + 1 ? (
                              <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
                            ) : null}
                            Przenieś treść na slajd
                          </Button>
                          <p className="text-[11px] text-muted-foreground">
                            Aktualizuje tekst na gotowym PNG. Nie rusza układu ani tła. Nie to samo co Złóż obrazki.
                          </p>
                          {syncSlideCopyM.isError && syncSlideCopyM.variables === idx + 1 ? (
                            <p className="text-xs text-destructive">
                              {(syncSlideCopyM.error as Error)?.message || "Nie udało się przenieść treści"}
                            </p>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  );
                })()}
              </CardContent>
            </Card>
            <CopyChatPanel
              messages={chatMessages}
              busy={Boolean(chatBusy)}
              canUndo={canUndoChat}
              disabled={!item || !selectedId || copyBusy}
              error={
                (copyChatM?.isError && (copyChatM.error as Error)?.message) ||
                (copyReviewOnDemandM?.isError && (copyReviewOnDemandM.error as Error)?.message) ||
                (copyChatUndoM?.isError && (copyChatUndoM.error as Error)?.message) ||
                ""
              }
              onSend={(message) => copyChatM.mutate(message)}
              onReviewRoles={() => copyReviewOnDemandM.mutate()}
              onUndo={() => copyChatUndoM.mutate()}
              reviewPending={copyReviewOnDemandM?.isPending}
              undoPending={copyChatUndoM?.isPending}
            />
          </div>
        ) : null}
        </TabsContent>

  );
}

